import { t } from '@exam-prep/i18n';
import { EXAM } from '../../exam-guard';
import { formatDuration } from '@exam-prep/ui';

/** Faint per-learner watermark over the whole screen (SSC Rankers League only). */
export function ExamWatermark({ background }: { background: string }) {
  return (
    <div
      aria-hidden
      data-testid="exam-watermark"
      className="pointer-events-none fixed inset-0 z-40 select-none"
      style={{ backgroundImage: background }}
    />
  );
}

export function ProtectionNotice({ text }: { text: string }) {
  return (
    <p
      role="status"
      className="fixed inset-x-3 top-14 z-50 rounded-xl border border-amber-300 bg-amber-100 px-3 py-2 text-center text-xs text-amber-900 shadow-lg"
    >
      {text}
    </p>
  );
}

export function PlayerHeader({ title, remaining }: { title: string; remaining: number }) {
  return (
    <header className="glass-bar sticky top-0 z-10 flex items-center justify-between gap-3 border-b px-3 py-2 text-sm">
      <span className="flex min-w-0 items-center gap-2">
        <img src="/brand/logo-64.webp" alt="" width={28} height={28} className="size-7 shrink-0" />
        <span className="truncate font-semibold">{title}</span>
      </span>
      <span className="timer-pill" data-low={remaining < 300_000} role="timer">
        <span aria-hidden>⏱</span> {formatDuration(remaining)}
      </span>
    </header>
  );
}

export function StatusBars({
  offline,
  waiting,
  managed,
  paused,
  expired,
  notice,
  onDismissNotice,
}: {
  offline: boolean;
  waiting: number;
  managed: boolean;
  paused: boolean;
  expired: boolean;
  notice: string | null;
  onDismissNotice: () => void;
}) {
  return (
    <>
      {offline || waiting > 0 ? (
        <p className="border-b border-amber-200 bg-amber-100 px-3 py-1.5 text-xs text-amber-900">
          {offline ? t('miniapp.player.offline', { n: waiting }) : t('miniapp.player.saving')}
        </p>
      ) : null}
      {managed && paused ? (
        <p
          role="status"
          className="border-b border-amber-200 bg-amber-100 px-3 py-1.5 text-xs text-amber-900"
        >
          {EXAM.paused}
        </p>
      ) : null}
      {managed && expired ? (
        <p
          role="status"
          className="border-b border-blue-200 bg-blue-100 px-3 py-1.5 text-xs text-blue-900"
        >
          {EXAM.timeUp}
        </p>
      ) : null}
      {notice ? (
        <button
          type="button"
          className="border-b border-blue-200 bg-blue-100 px-3 py-1.5 text-left text-xs text-blue-900"
          onClick={onDismissNotice}
        >
          {notice}
        </button>
      ) : null}
    </>
  );
}
